import axios from "axios";

// All KYC verification now goes through the sales backend instead of calling
// Surepass directly. The Surepass token used to live in this file as
// REACT_APP_SUREPASS_TOKEN, which meant it shipped inside the production JS
// bundle and could be read out of devtools by anyone who opened the app.
//
// The backend proxy replays Surepass's status code and response body verbatim,
// so the shapes these functions resolve and reject with are unchanged: callers
// keep reading `res.data.data` on success and `err.response.data.message` on
// failure (including the exact "No GSTIN Found." check the registration flow
// depends on). See routes/surepass.js in SALES-APP-BACKEND-NODE-API.

// The sales backend base URL. The env value normally carries a trailing slash,
// matching the convention used for message/, mail/ and cpInvoices/ — the
// trim keeps this correct whether or not that slash is present.
const API_ROOT = String(
  process.env.REACT_APP_SEND_OTP_MESSAGE_A2P_SERVICE || ""
).replace(/\/+$/, "");
const SUREPASS_BASE = `${API_ROOT}/api/surepass`;

async function getPAN_cardDetails(panCardNumber) {
  const response = await axios.post(`${SUREPASS_BASE}/pan`, {
    id_number: panCardNumber,
  });

  return response;
}

async function getAccountDetails(postBody) {
  const response = await axios.post(`${SUREPASS_BASE}/bank-verification`, postBody);

  return response;
}

async function getAadharCardDetails(aadharNumber) {
  // less_info is still deliberately not sent — it was dropped on 13 Apr, 2023
  // because verification failed for 461582983626 with it present.
  const response = await axios.post(`${SUREPASS_BASE}/aadhaar-validation`, {
    id_number: aadharNumber,
  });

  return response;
}

async function getGSTNumber(panCardNumber) {
  const response = await axios.post(`${SUREPASS_BASE}/gstin-by-pan`, {
    id_number: panCardNumber,
  });

  return response;
}

async function getGSTInfo(gstNumber) {
  // filing_status_get is applied by the backend so the response keeps the
  // filing-status fields the profile and registration forms read.
  const response = await axios.post(`${SUREPASS_BASE}/gstin`, {
    id_number: gstNumber,
  });

  return response;
}

async function getReraDetails(reraNumber) {
  // The agent/maharashtra scope and the separate RERA host are applied by the
  // backend.
  const response = await axios.post(`${SUREPASS_BASE}/rera`, {
    registration_number: reraNumber,
  });

  return response;
}

export { getPAN_cardDetails, getAccountDetails, getAadharCardDetails, getGSTNumber, getGSTInfo, getReraDetails }
